import {Directive, Inject, LOCALE_ID, OnDestroy, OnInit} from '@angular/core';
import {ShortLanguageKey} from '@app/shared/util/language-helper';
import {Subject, timer} from 'rxjs';
import {skipWhile, take, takeUntil} from 'rxjs/operators';
import {Router} from '@angular/router';

declare global {
	interface Window {
		usercentrics: any;
	}
}

@Directive({
	selector: '[appInitializeUsercentrics]'
})
export class InitializeUsercentricsDirective implements OnInit, OnDestroy {
	readonly #languageShortCode: ShortLanguageKey;
	readonly #destroyed$ = new Subject<void>();

	constructor(@Inject(LOCALE_ID) locale: string, private router: Router) {
		this.#languageShortCode = locale.substring(0, 2).toLowerCase() as ShortLanguageKey;
	}

	ngOnInit(): void {
		this.initWhenReady();
	}

	ngOnDestroy(): void {
		this.#destroyed$.next();
		this.#destroyed$.complete();
	}

	private initWhenReady(): void {
		const ready$ = timer(0, 250).pipe(
			skipWhile(() => !this.usercentricsIsReady()),
			take(1),
			takeUntil(this.#destroyed$)
		);

		ready$.subscribe(() => this.init());
	}

	private init(): void {
		if (window.usercentrics) {
			window.usercentrics.updateLanguage(this.#languageShortCode);
			this.makeUsercentricsVisible();
		}

		document.addEventListener('click', event => {
			const target = event.target as Element | undefined;

			if (target?.matches('[href="#uc-central-modal-show"], [href="#uc-corner-modal-show"]')) {
				this.makeUsercentricsVisible();
				event.preventDefault();
			}

			if (target?.matches('#uc-full-optin-description .privacy')) {
				this.router.navigate(['static-page', 'privacy']);
				event.preventDefault();
			}
		});
	}

	private makeUsercentricsVisible(): void {
		const usercentricsButton = this.getUsercentricsButton();
		usercentricsButton?.classList.add('visible');
	}

	private usercentricsIsReady(): boolean {
		return !!this.getUsercentricsButton();
	}

	private getUsercentricsButton(): HTMLElement | null {
			return document.getElementById('usercentrics-button');
	}
}
